import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { convertDate } from "utils/formatDate";
import { getDate } from "utils/formatDate";
import DateTimePicker from "../../../GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";

export const GiaoDichGopVon = ({
  dataNguonVon,
  onChangeDate,
  updateTextValue,
  onChangeNumber,
  listUser,
  updateDropdown,
  errors1,
  errors2,
  errors3,
}) => {
  return (
    <>
      <div className="card-header  mt-1">
        <a className="card-title lead info collapsed" href={() => false}>
          <h3>Giao dịch</h3>
        </a>
      </div>
      <div className="card-collapse collapse show">
        <div className="card-content">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row">
                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput1"
                    >
                      <span> Ngày giao dịch</span>
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        onChange={onChangeDate("ngaygiaodich")}
                        value={convertDate(dataNguonVon.ngaygiaodich)}
                        name="ngaygiaodich"
                      ></DateTimePicker>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput1"
                    >
                      Nhân viên giao dịch
                    </label>
                    <br />
                    <select
                      name="nhanviengiaodich"
                      className="selectBox form-control input-sm"
                      value={dataNguonVon.nhanviengiaodich}
                      onChange={updateDropdown("nhanviengiaodich")}
                    >
                      {listUser &&
                        listUser.map((item, idx) => (
                          <option
                            key={"objComboStore1" + idx}
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                    </select>
                    {errors1.nhanviengiaodich && (
                      <span className="canh-bao-red">
                        {errors1.nhanviengiaodich}
                      </span>
                    )}
                  </div>
                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-2 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-4"
                      wrapperClass="form-group row"
                      labelText="Số tiền"
                      inputProps={{
                        name: "sotien",
                        onChange: onChangeNumber("sotien"),
                        value: formatNumber(dataNguonVon.sotien),
                      }}
                    ></TextInputTwoRow>
                  </div>
                  <div className="col-md-3">
                    {errors2.sotien && (
                      <div className="form-group row">
                        <label
                          className="label-control color7-bold"
                          for="userinput2"
                        ></label>
                        <br />
                        <div className="col-md-10">
                          <span
                            className="canh-bao-red"
                            style={{ marginBottom: "10px" }}
                          >
                            {errors2.sotien}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-12">
                    <label className="label-control color7-bold">Ghi chú</label>
                    <textarea
                      rows="1"
                      style={{ minHeight: "80px" }}
                      className="form-control input-sm"
                      name="ghichu"
                      value={dataNguonVon.ghichu}
                      onChange={updateTextValue("ghichu")}
                    ></textarea>{" "}
                    {errors3.ghichu && (
                      <span className="canh-bao-red">{errors3.ghichu}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
